export function GroupMeetingSvg({ fillColor = "#FFFFFF", size = 50 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0476 4.73179C19.0476 4.44914 19.1732 4.18109 19.3903 4.00015L23.7713 0.349351C24.3916 -0.167575 25.3333 0.273528 25.3333 1.08099V12.7285C25.3333 13.536 24.3916 13.9771 23.7713 13.4602L19.3903 9.80938C19.1732 9.62843 19.0476 9.36039 19.0476 9.07774V4.73179Z"
        fill={fillColor}
      />
      <path
        d="M0 1.52381C0 0.682233 0.682233 0 1.52381 0H13.5238C16.0485 0 18.0952 2.0467 18.0952 4.57143V12.4762C18.0952 13.3178 17.413 14 16.5714 14H4.57143C2.0467 14 0 11.9533 0 9.42857V1.52381Z"
        fill={fillColor}
      />
    </svg>
  );
}
